import { useCallback, useEffect, useState } from "react"
import useResizeWindow from './useResizeWindow'
const isMobileSize = () => {
  const [isMobile, setIsMobile] = useState(false)

  const onResize = useCallback(() => {
    setIsMobile(document.body.clientWidth < 768)
  }, [])

  useResizeWindow(onResize)

  useEffect(() => {
    onResize()
  }, [])

  return isMobile
}

export default isMobileSize